export enum TeamPageTabs {
  AgencyUsers = 'Agency Users',
  ManageTeams = 'Manage Teams',
  UrbanXTeam = 'URBAN X Team',
}
